var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-icon',{attrs:{"size":_vm.size,"icon":_vm.icon,"type":_vm.type,"icons":_vm.icons,"view-box":_vm.viewBox,"icon-lib":_vm.iconLib}})
}
var staticRenderFns = []

export { render, staticRenderFns }